import { AthleteProfile } from '../types';
import { getLevelInfo, LevelInfo } from './levelUtils';
import { fireEliteSeriesConfetti } from './badgeEvaluator';

export interface ClaimXpResult {
  updatedUser: AthleteProfile;
  previousLevel: number;
  newLevel: number;
  leveledUp: boolean;
  xpClaimed: number;
  unlockedMilestoneTitle?: string;
  isMilestoneReached: boolean;
  milestoneTier?: 10 | 25 | 50;
  levelInfo: LevelInfo;
}

/**
 * AchievementXPIntegration Helper
 * Allows athletes to claim specific achievement points, which then flow into
 * the global XP and 50-level progression system, updating their profile level accordingly.
 */
export function claimAchievementXP(
  user: AthleteProfile,
  xpAmount: number,
  badgeName?: string
): ClaimXpResult {
  const currentXp = user.xp || 0;
  const newXp = currentXp + Math.max(0, xpAmount);

  const oldLevelInfo = getLevelInfo(currentXp);
  const newLevelInfo = getLevelInfo(newXp);

  const previousLevel = oldLevelInfo.level;
  const newLevel = newLevelInfo.level;
  const leveledUp = newLevel > previousLevel;

  const isMilestoneReached = leveledUp && (newLevel === 10 || newLevel === 25 || newLevel === 50);
  let milestoneTier: 10 | 25 | 50 | undefined = undefined;
  if (isMilestoneReached) {
    milestoneTier = newLevel as 10 | 25 | 50;
    fireEliteSeriesConfetti();
  }

  const updatedUser: AthleteProfile = {
    ...user,
    xp: newXp,
    level: newLevel,
    levelTitle: newLevelInfo.levelTitle,
  };

  return {
    updatedUser,
    previousLevel,
    newLevel,
    leveledUp,
    xpClaimed: xpAmount,
    unlockedMilestoneTitle: badgeName,
    isMilestoneReached,
    milestoneTier,
    levelInfo: newLevelInfo,
  };
}
